import axios from 'axios';

const API_URL = process.env.REACT_APP_SERVER_URL + '/app/sqlaccount';

function authHeader() {
    const token = localStorage.getItem('gpcwstoken_kw');
    return { Authorization: `Bearer ${token}` };
}

export interface DoQrSyncResult {
    warehouseId: number;
    label: string;
    docdate?: string;
    checked?: number;
    processed?: unknown[];
    errors?: string[];
    error?: string;
}

const SqlAccountDoQrSyncService = {
    // Manually runs the same DO QR sync the scheduled job does, for today, across every
    // configured warehouse - the live job only ever looks at "today" on its own schedule.
    syncToday: async (): Promise<{ success: boolean; results: DoQrSyncResult[] }> => {
        const response = await axios.post(
            `${API_URL}/do-qr/backfill`,
            { days: 1 },
            { headers: authHeader() }
        );
        return response.data;
    },
};

export default SqlAccountDoQrSyncService;
